module.exports = __webpack_public_path__ + "feature-highlight-3-1x-54323809cc9d8a7095fca1097b7b0d25.webp";